import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ko'

export default createLendingBundle(whitepaper)
